import React, { useEffect, useState } from 'react'

import Loader from '@Pure/Loader'

import request from '@function/ajax/request'
import bemit   from '@function/bemit'

const { moment } = window;

const header =
[
	{ label: 'Avoir n°', name: 'number' },
	{ label: 'Règlement', name: 'payment_status' },
	{ label: 'Date', name: 'date' },
	{ label: 'PDF', name: 'PDF' }
];

export default function OrderCreditNotes ({ bill })
{
	const [loading, setLoading] = useState(false);
	const [credit_notes, setCreditNotes] = useState([]);

	useEffect(function ()
	{
		if (!bill) return;

		const controller = new AbortController();

		setLoading(true);

		(async function ()
		{
			try
			{
				var { credit_notes } = await request('/bills/get-bill-credit-notes')
				.config({ controller, keyword: 'action' })
				.post({ bill_id: bill });
			}
			catch (update)
			{
				if (controller?.signal?.aborted) return;

				setLoading(false);

				return;
			}

			setLoading(false);

			setCreditNotes(credit_notes || []);
		})();

		return () => { controller?.abort?.(); };
	},
	[bill]);

	if (!credit_notes?.length) return null;

	const infos = credit_notes.map(function (credit_note)
	{
		const chip_color = credit_note.payment_status === 'paid'
		? 'green'
		: credit_note.payment_status === 'partially_paid'
		? 'blue'
		: 'red';

		return (
			<div className="c-order-product__CN-infos" key={ credit_note.id }>
				<div className="c-order-product__CN-cell CN-number">
					Avoir { credit_note.text_number }
				</div>

				<div className="c-order-product__CN-cell CN-payment_status">
					<div className={ bemit('c-chip', [chip_color]) }>
						<span className="c-chip__text">
							{
								credit_note.payment_status === 'paid'
								? 'Réglé'
								: credit_note.payment_status === 'partially_paid'
								? 'Partiellement réglé'
								: 'En attente'
							}
						</span>
					</div>
				</div>

				<div className="c-order-product__CN-cell CN-date">
					{ moment(credit_note.date).format('DD/MM/YYYY') }
				</div>

				<div className="c-order-product__CN-cell CN-PDF">
					<a className="c-btn c-btn--icon c-btn--ghost" target="_blank"
						rel="noreferrer" type="application/pdf"
						href={ '/PDF/avoir/' + credit_note.id }>
						<svg className="o-svg-icon o-svg-icon--PDF c-btn__icon">
							<use xlinkHref="/images/icons.svg#svg-icon-PDF"></use>
						</svg>
						PDF
					</a>
				</div>
			</div>
		);
	});

	const header_cells = header.map(function ({ label, name })
	{
		return (
			<div className={ 'c-order-product__CN-cell CN-' + name } key={ name }>
				{ label }
			</div>
		);
	});

	return (
		<div className="c-order-product c-order-product--line c-order-product--CN">

			<div className="c-order-product__CN-list">
				<div className="c-order-product__CN-infos is-CN-header">
					{ header_cells }
				</div>
				{ infos }
			</div>

			{
				loading ?
				(
					<Loader bemit={ ['bg-white', 'primary'] }
						className="c-loader"
					/>
				)
				: undefined
			}
		</div>
	);
}